import type { ReactNode } from 'react';
import type { LogoLangCode } from '@standardsdigital/ui-components/Logo';
import Logo, { Client } from '@standardsdigital/ui-components/Logo';
import BsiLogo from '@/components/logos/BsiLogo';

const customLogos: Partial<Record<Client, ReactNode>> = {
  [Client.BSI]: <BsiLogo />,
};

const getClientLogo = (
  clientCode: Client,
  langCode: LogoLangCode | undefined,
): ReactNode =>
  customLogos[clientCode] ?? <Logo clientCode={clientCode} langCode={langCode} />;

export default getClientLogo;
